import { lazy, Suspense } from "react";
import { Routes, Route, useLocation, Navigate } from "react-router-dom";
import { Container } from "react-bootstrap";

const LandingPage = lazy(() => import("../Components/LandingPage/LandingPage"));
const SteeringGroupsPage = lazy(
  () => import("../Components/SteeringGroupsPage/SteeringGroupsPage"),
);
const AboutPage = lazy(() => import("../Components/AboutUs/About"));
const ChallengePage = lazy(
  () => import("../Components/ChallengeComponent/Challenge"),
);
const FaqPage = lazy(() => import("../Components/FAQ/Faq"));
const TermsOfUsePage = lazy(
  () => import("../Components/TermsOfUse/TermsOfUse"),
);
const PrivacyNoticePage = lazy(
  () => import("../Components/PrivacyNotice/PrivacyNotice"),
);

const HelpCentreComponent = lazy(
  () => import("../Components/AdminPanel/HelpCentre/HelpCentrepage"),
);
const AdminPage = lazy(() => import("../Components/AdminPanel"));
const UserProfilePage = lazy(
  () => import("../Components/AdminPanel/UserProfile/Userprofile"),
);
const Favourite = lazy(
  () => import("../Components/AdminPanel/FavouritesComponent/Favourite"),
);

const RecentlyStandards = lazy(
  () => import("../Components/RecentlyStandardsComponents/RecentlyStandards"),
);

const StandardsCategoryView = lazy(
  () => import("../Components/StandardsCategoryView/StandardsCategoryView"),
);

const SearchPage = lazy(
  () => import("../Components/SearchLandingPageComponent/SearchPage"),
);
const SearchedPage = lazy(
  () => import("../Components/SearchLandingPageComponent/SearchedPage"),
);
const FoldersPage = lazy(
  () => import("../Components/StandardsCategorySpecific/FoldersPage"),
);
const ReportsPage = lazy(
  () => import("../Components/ReportsComponent/Reports"),
);
const ApiPlayground = lazy(
  () => import("../Components/ApiPlayground/ApiPlayground"),
);
const NewStandardPage = lazy(
  () => import("../Components/NewStandard/NewStandard"),
);

// Keep spinner synchronous because it's used as Suspense fallback
import ProgressSpinnerComponent from "../Components/Auth/ProgressSpinner";
import { ProtectedRoute } from "./ProtectedRoute/ProtectedRoute";

const GeneralSettings = lazy(
  () => import("../Components/AdminPanel/Settings/GeneralSettings"),
);

const AppearanceSettings = lazy(
  () => import("../Components/AdminPanel/Settings/AppearanceSettings"),
);

const NotificationsSettings = lazy(
  () => import("../Components/AdminPanel/Settings/NotificationsSettings"),
);

//role -> "admin", "internal-user", "external-user"
function RoutesComponent() {
  const location = useLocation();

  return (
    <Container fluid style={{ marginBottom: "65px" }}>
      <Suspense fallback={<ProgressSpinnerComponent />}>
        <Routes location={location} key={location.pathname}>
          <Route path="/" element={<LandingPage />} />
          {/* <Route path="/steeringGroups" element={<SteeringGroupsComponent />} /> */}
          <Route path="/about-us" element={<AboutPage />} />
          <Route path="/challenge" element={<ChallengePage />} />
          <Route path="/faq" element={<FaqPage />} />
          <Route path="/reports" element={<ReportsPage />} />{" "}
          <Route path="/faq/:categoryId" element={<FaqPage />} />
          <Route
            path="/recently-added-standards"
            element={<RecentlyStandards />}
          />
          <Route
            element={<ProtectedRoute allowedRoles={["admin"]} redirectTo="/" />}
          >
            <Route
              path="/admin-panel/:adminCategory/*"
              element={<AdminPage />}
            />
          </Route>
          {/* <Route path="/admin-panel/:adminCategory" element={<AdminPage />} /> */}
          {/* Privacy and Terms Routes */}
          <Route path="/privacy-notice" element={<PrivacyNoticePage />} />
          <Route path="/terms-of-use" element={<TermsOfUsePage />} />
          <Route
            path="/steering-groups"
            element={
              <Navigate to="/standards-category-specific?cid=3" replace />
            }
          />
          {/* Settings Routes */}
          <Route path="/settings" element={<GeneralSettings />} />
          <Route path="/settings/appearance" element={<AppearanceSettings />} />
          <Route
            path="/settings/notifications"
            element={<NotificationsSettings />}
          />
          {/* Help Centre Route */}
          <Route path="/help-centre" element={<HelpCentreComponent />} />
          <Route path="/help-center" element={<Navigate to="/help-centre" replace />} />
          {/* <Route
            path="profile/favourite-standards"
            element={<FavouriteStandardsPage />}
          /> */}
          <Route
            path="/profile/:profileCategory"
            element={<UserProfilePage />}
          />
          <Route
            path="/category/:categoryId"
            element={<StandardsCategoryView />}
          />
          <Route path="/search" element={<SearchPage />} />
          <Route path="/searchedPage" element={<SearchedPage />} />
          <Route
            path="/standards-category-specific"
            element={<FoldersPage />}
          />
          <Route
            element={<ProtectedRoute allowedRoles={["admin"]} redirectTo="/" />}
          >
            <Route path="/new-standard" element={<NewStandardPage />} />
          </Route>
          <Route path="/api-playground" element={<ApiPlayground />} />
        </Routes>
      </Suspense>
    </Container>
  );
}
export default RoutesComponent;
